import { useMemo } from 'react';

import { orderDirectoryProfiles, type DirectoryItem } from '../model';

import type { ExpertProfile } from '@/util/mapDirectoryProfiles';

/** The directory's profiles in display order. The rules are `orderDirectoryProfiles`. */
export function useOrderedDirectoryProfiles(
  filteredProfiles: ExpertProfile[],
  searchQuery: string,
  focusId: string,
  productTypeId: string,
  numColumns: number
): DirectoryItem[] {
  return useMemo(
    () => orderDirectoryProfiles(filteredProfiles, searchQuery, focusId, productTypeId, numColumns),
    [filteredProfiles, searchQuery, focusId, productTypeId, numColumns]
  );
}
